export function getBaseUrl (windowUrl, currentPath) {
  let url = windowUrl
  if (url.indexOf("?") > 0) {
    url = url.substring(0, url.indexOf("?"));
  }
  if (url.indexOf("#") > 0) {
    url = url.substring(0, url.indexOf("#"));
  }
  if (currentPath && url.endsWith(currentPath)) {
    url = url.substring(0, url.length - currentPath.length)
  }
  return url
}

export function getAbsoluteUrl (base, relative) {
  if (relative.startsWith('http')) {
    return relative
  }
  if (base.endsWith('/') && relative.startsWith('/')) {
    relative = relative.slice(1)
  }

  return base + relative
}
